<template>
  <div class="table-light">
    <!-- Search -->
    <div class="col-sm-12 col-md-6">
      <div id="tickets-table_filter" class="dataTables_filter text-md-end">
        <label class="d-inline-flex align-items-center">
          Αναζήτηση:
          <b-form-input
            v-model="filter"
            type="search"
            class="form-control form-control-sm ms-2"
          ></b-form-input>
        </label>
      </div>
    </div>
    <!-- End search -->
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="deviceUserAttendances"
        :fields="fields"
        responsive="xs"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      ></b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-start">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- <div class="table-responsive">
    
    <table class="table mb-0">
      <thead class="table-light">
        <tr>
          <th>A/A</th>
          <th>Όνομα</th>
          <th>Αριθμός Κάρτας</th>
          <th>Ημερομηνία</th>
        </tr>
      </thead>

      <tbody v-if="deviceUserAttendances && deviceUserAttendances.length > 0">
        <tr v-for="(person, index) in deviceUserAttendances" :key="index">
          <th scope="row">{{ index + 1 }}</th>
          <td>{{ person.name }}</td>
          <td>{{ person.card }}</td>
          <td>
            {{ formatTimestamp(person.timestamp) }}
          </td>
        </tr>
      </tbody>
    </table> -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    deviceUserAttendances: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: "name", sortable: true, label: "Ονομ/νυμο" },
        { key: "card", sortable: true, label: "Αριθμός Κάρτας" },
        { key: "timestamp", sortable: true, label: "Ημερομηνία" },
      ],
      perPage: 50,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      currentPage: 1,
      todocurrentPage: 1,
      totalRows: 1,
      todoTotalRows: 1,
    };
  },
  computed: {
    rows() {
      return this.deviceUserAttendances.length;
    },
  },

  methods: {
    formatTimestamp(timestamp) {
      return moment(timestamp).format("DD/MM/YYYY, H:mm:ss");
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },
  },
};
</script>
